import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AdminService } from 'src/app/_services/admin.service';

@Component({
  selector: 'app-admin',
  templateUrl: './setCrimson.component.html',
  styleUrls: ['./setCrimson.component.scss']
})
export class AdminSetCrimsonComponent implements OnInit {
  constructor(private toastrs: ToastrService, private adminService: AdminService) {}

  personnages!: any[];

  ngOnInit(): void {
    this.adminService.listPersonnage().subscribe(l => {
      this.personnages = l;
    });
  }



  onSubmit(id: any, crimsonDisponible: any) {
    this.adminService.setPersonnageCrimson({
      commandId: crypto.randomUUID(),
      personnageId: id,
      crimsonDisponible: crimsonDisponible
    })
    .subscribe({
      next: (result) => {
        this.toastrs.info("Nombre de crimson changé.");
      }
    });
  }
}
